import { createGetKcContext } from "keycloakify/login";

export type KcContextExtension =
  | { pageId: "login.ftl" }
  | { pageId: "error.ftl" };

//NOTE: In most of the cases you do not need to overload the KcContext, you can
// just call createGetKcContext(...) without type arguments.
// You want to overload the KcContext only if:
// - You have custom plugins that add some values to the context (like https://github.com/micedre/keycloak-mail-whitelisting that adds authorizedMailDomains)
// - You want to add support for extra pages that are not yey featured by default, see: https://docs.keycloakify.dev/contributing#adding-support-for-a-new-page
export const { getKcContext } = createGetKcContext<KcContextExtension>({
  mockData: [
    {
      pageId: "login.ftl",
      locale: {
        currentLanguageTag: "en",
      },
      social: {
        providers: [
          {
            displayName: "Apple",
            providerId: "apple",
            loginUrl:
              "/auth/realms/studio-dev/broker/apple/login?client_id=gsep-service&tab_id=rlc2dfPJJ3I&session_code=LD1d8_hh1-FDvQiOtncEVPjD9yS6rra3ZMiooZrLvyE",
            iconClasses: "fa fa-apple",
            alias: "apple",
          },
          {
            displayName: "Google",
            providerId: "google",
            loginUrl:
              "/auth/realms/studio-dev/broker/google/login?client_id=gsep-service&tab_id=rlc2dfPJJ3I&session_code=LD1d8_hh1-FDvQiOtncEVPjD9yS6rra3ZMiooZrLvyE",
            iconClasses: "fa fa-google",
            alias: "google",
          },
        ],
      },
    },
    {
      pageId: "error.ftl",
    },
  ],
  // Defined in vite.config.ts
  // See: https://docs.keycloakify.dev/environnement-variables
  mockProperties: {
    MY_ENV_VARIABLE: "Mocked value",
  },
});

export const { kcContext } = getKcContext({
  // Uncomment to test the login page for development.
  mockPageId: "login.ftl",
});

export type KcContext = NonNullable<
  ReturnType<typeof getKcContext>["kcContext"]
>;
